import React from "react";

import { CognitiveLoadWithStats as CognitiveLoadWithStatsComponent } from "heat-next";
import styled from "styled-components";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

interface CognitiveLoadWithStatsProps {
    onClick: (event: any) => void;
    subDimensionsData?: any;
}

/* wrapper needed to render full ContentLoader heigh */
const LoadingWrapper = styled.div`
    height: 26.3125rem;
`;

const CognitiveLoadWithStats: React.FC<CognitiveLoadWithStatsProps> = ({
    onClick,
    subDimensionsData,
}) => {
    const {
        cognitiveLoadWithStatsData,
        isFetchingCognitiveLoadWithStats,
        isErrorCognitiveLoadWithStats,
    } = useSessionDetailsContext();

    const isEmptyState = () => {
        if (subDimensionsData) {
            return false;
        } else if (
            !isErrorCognitiveLoadWithStats &&
            (!cognitiveLoadWithStatsData ||
                cognitiveLoadWithStatsData === null ||
                cognitiveLoadWithStatsData.length === 0)
        ) {
            return true;
        }
    };

    if (isFetchingCognitiveLoadWithStats) {
        return (
            <LoadingWrapper>
                <ContentLoader height="26.3125rem" />
            </LoadingWrapper>
        );
    }

    if (isErrorCognitiveLoadWithStats && !isFetchingCognitiveLoadWithStats) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="23.3125rem"
                />
            </ComponentWrapper>
        );
    }

    if (isEmptyState()) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:cognitive-load-with-stats:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="23.3125rem"
                />
            </ComponentWrapper>
        );
    }

    return (
        <CognitiveLoadWithStatsComponent
            data={subDimensionsData ? subDimensionsData : cognitiveLoadWithStatsData}
            onClick={onClick}
        />
    );
};

export default CognitiveLoadWithStats;
